<img [lazyLoad]="src" [alt]="title" [ngStyle]="{visibility:isLoading?'hidden':'visible'}" (load)="hideLoader()" (error)="hideLoader()">
<mat-spinner *ngIf="isLoading" diameter="30" strokeWidth="1" color="primary"></mat-spinner>
